module.exports = __webpack_public_path__ + "static/media/input.8dbe9547.svg";